import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser, onAuthStateChange, isAdmin } from '../utils/auth';

const AuthContext = createContext({});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdminUser, setIsAdminUser] = useState(false);

  useEffect(() => {
    // Check active session on mount
    const checkUser = async () => {
      const { success, user: currentUser } = await getCurrentUser();
      if (success && currentUser) {
        setUser(currentUser);
        setIsAdminUser(isAdmin(currentUser));
        // Always ensure userEmail is stored for data sync across the app
        if (currentUser.email) {
          try { localStorage.setItem('userEmail', currentUser.email); } catch (e) {}
        }
      }
      setLoading(false);
    };

    checkUser();

    // Listen for auth changes
    const { data: { subscription } } = onAuthStateChange((event, session) => {
      if (session?.user) {
        setUser(session.user);
        setIsAdminUser(isAdmin(session.user));
        // Always ensure userEmail is stored for data sync across the app
        if (session.user.email) {
          try { localStorage.setItem('userEmail', session.user.email); } catch (e) {}
        }
      } else {
        setUser(null);
        setIsAdminUser(false);
      }
      setLoading(false);
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  const value = {
    user,
    isAdminUser,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
